import { FC } from 'react';
import { AllieEllipseProps } from './Ellipse.types';
import './Ellipse.css';

export const AllieEllipse: FC<AllieEllipseProps> = ({ allieType, size, className, ...props }) => (
  <div
    className={`allie-ellipse allie-ellipse-${allieType} allie-ellipse-size-${
      size || 'normal'
    } ${className}`}
    {...props}
  />
);
